<header [ngClass]="{ business: corpPartner.updateBgColor || businessUser }">
  <ngc-app-sec-links-seo></ngc-app-sec-links-seo>
  <div
    #ngcGlobalElementRef
    *ngIf="!shopHeader || alternateFlow.enabled"
    [ngClass]="{ 'advisory-page-content': isAlertAdvisory }"
    class="header"
    ngc-KeyboardFocus
  >
    <ngc-switching-account
      *ngIf="isloggedIn && contentInterstitialBanner"
      [bannerDetails]="contentInterstitialBanner"
      [isDesktop]="deviceTypes.isDesktop"
    ></ngc-switching-account>
    <nav
      [ngClass]="{
        darkSiteEnabled: !isDarkSiteEnabled,
        'margin-rt-0': !deviceTypes.isDesktop
      }"
      [style.top.px]="navbarTop"
      aria-label="main"
      class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark"
    >
      <div
        *ngIf="isDarkSiteEnabled && !isLightHeaderFooterEnable"
        class="container"
      >
        <a
          #toggle
          (click)="navigationDrawer()"
          [attr.aria-expanded]="navigation ? 'false' : 'true'"
          [attr.aria-label]="
            navigation ? 'Navigation menu' : 'Close navigation menu'
          "
          [ngClass]="{ active: !navigation, 'd-none': alternateFlow.enabled }"
          att.aria-controls="headerLinksContainer"
          class="hamburger-icon d-lg-none"
          href="javascript:void(0)"
          id="hamburger-icon"
          title="Menu"
        >
          <span class="line line-1"></span>
          <span class="line line-2"></span>
          <span class="line line-3"></span>
          <span aria-hidden="true" class="sr-only">Navigation menu</span>
        </a>
        <ngc-my-trips-link
          *ngIf="alternateFlow.enabled"
          [alternateFlow]="alternateFlow"
          [findTripData]="findTripData"
          [nextgenReshopHeaderData]="nextgenReshopHeader"
          [alternativeText]="alternativeText"
        ></ngc-my-trips-link>
        <ngc-search
          *ngIf="enableSearch && !hideSearchButton"
          [ngClass]="{ 'd-none': navigation, 'd-inline-block': !navigation }"
          class="d-lg-none float-right search-ham"
        ></ngc-search>
        <ngc-logo
          [corpPartner]="corpPartner"
          [displayBusinessTypeSection]="displayBusinessTypeSection"
          [mobileDarkSiteLogo]="isDarkSiteEnabled"
          [ngClass]="{ 'idp-global-nav-trip-logo': alternateFlow.enabled }"
          class="d-none d-lg-block"
        ></ngc-logo>
        <ngc-login
          #loggedinComponent
          (crpNamesInfo)="getCrpNames($event)"
          (custId)="getCustId($event)"
          (edpFlag)="setEdpFlag($event)"
          (isCheckInEligible)="getCheckInEligible($event)"
          (isLoggedinFlag)="getLoggedIn($event)"
          (prefCity)="getPrefCity($event)"
          *ngIf="toggle?.offsetParent !== null"
          [corpPartner]="corpPartner"
          [displayBusinessTypeSection]="displayBusinessTypeSection"
          [isAlertAdvisory]="isAlertAdvisory"
          [isTooltiptoShow]="showTooltip"
          [ngClass]="{ 'd-block': navigation, 'd-none': !navigation }"
          class="d-none d-lg-none"
        ></ngc-login>
        <div
          *ngIf="!alternateFlow.enabled"
          [@navigation]="navigation"
          [style.top.px]="widgetContainerTop"
          class="bg-dark navbar-collapse main-container"
          id="headerLinksContainer"
          style="display: none; margin-left: 0"
        >
          <ngc-app-navigation-links
            (navItemClicked)="toggleContent($event)"
            (openAdvanceSearch)="recievOpenAdvanceSearch($event)"
            [inMobile]="toggle?.offsetParent !== null"
            [isMobileDevice]="isMobileDevice"
            [isNotHome]="isNotHome"
            [isSlimHeader]="isSlimHeader"
            [isWarmState]="isWarmState"
            [isloggedIn]="isloggedIn"
            [newNavItem]="selectedNavItem"
            [showCheckInByDefault]="isCheckInEligible"
          ></ngc-app-navigation-links>
          <div class="mobile-container row align-items-center">
            <span
              *ngIf="toggle?.offsetParent !== null"
              [ngClass]="{ 'text-center': !isHamberger }"
              class="contact-us-container col-12 col-md-2"
            >
              <a
                [attr.href]="contentContactUs?.contactUsUrl"
                id="contact-us-link"
              >
                {{ contentContactUs?.contactUsLabel }}
              </a>
            </span>
            <ngc-language-selector
              *ngIf="toggle?.offsetParent !== null && !disableCLS"
              class="col-12 col-md-9 lang-selector-hamburger"
              isHamberger="true"
            ></ngc-language-selector>
          </div>
          <div *ngIf="isloggedIn" class="d-lg-none logout-section">
            <a
              (click)="logOut()"
              class="col logout-btn"
              href="javascript:void(0);"
              role="button"
            >
              {{ contentMyFlightPanel?.logoutLabel }}
            </a>
          </div>
        </div>
        <div
          [ngClass]="{ 'd-none': !navigation, 'd-flex': navigation }"
          class="d-flex right-rail-container flex-row"
        >
          <ng-container *ngFor="let item of auxiliaryArr">
            <ng-container [ngSwitch]="item.id">
              <ngc-notification
                (modalServiceRef)="saveModalServiceRef($event)"
                *ngSwitchCase="'notification'"
                [isAlertAdvisory]="isAlertAdvisory"
                [isloggedIn]="isloggedIn"
                [ngClass]="{ 'd-block': navigation }"
                class="d-none"
              ></ngc-notification>
              <ng-container *ngIf="enableSearch && !hideSearchButton">
                <ngc-search
                  (modalServiceRef)="saveModalServiceRef($event)"
                  *ngSwitchCase="'searchfeed'"
                  [isAlertAdvisory]="isAlertAdvisory"
                  class="d-none d-lg-block"
                ></ngc-search>
              </ng-container>
              <ng-container *ngSwitchCase="'login'">
                <ngc-login
                  #loggedinComponent
                  (crpNamesInfo)="getCrpNames($event)"
                  (custId)="getCustId($event)"
                  (disableBusinessPicker)="disableBusinessPage($event)"
                  (edpFlag)="setEdpFlag($event)"
                  (isCheckInEligible)="getCheckInEligible($event)"
                  (isLoggedinFlag)="getLoggedIn($event)"
                  (modalServiceRef)="saveModalServiceRef($event)"
                  (prefCity)="getPrefCity($event)"
                  *ngIf="toggle?.offsetParent === null"
                  [corpPartner]="corpPartner"
                  [displayBusinessTypeSection]="displayBusinessTypeSection"
                  [isAlertAdvisory]="isAlertAdvisory"
                  [isTooltiptoShow]="showTooltip"
                ></ngc-login>
              </ng-container>
              <!-- DDCFB -->
              <ng-container *ngSwitchCase="'profileSelector'">
                <!--*ngSwitchCase="'businessType'"-->
                <ng-container
                  *ngIf="
                    (isloggedIn || isWarmState) &&
                    displayBusinessTypeSection &&
                    !restrictProfileSelector &&
                    isReady
                  "
                >
                  <ngc-business-user
                    [alreadyLogged]="isloggedIn"
                    [crpInfo]="crpInfo"
                    [hasBusinessOnly]="hasCorpCookie"
                    [isWarmState]="isWarmState"
                  ></ngc-business-user>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <!-- Darksite logo is not needed for LightHeaderFooterEnable  -->
      <div
        *ngIf="!isDarkSiteEnabled && !isLightHeaderFooterEnable"
        class="container"
      >
        <ngc-logo
          [corpPartner]="corpPartner"
          [displayBusinessTypeSection]="displayBusinessTypeSection"
          [isLightHeaderFooterEnable]="isLightHeaderFooterEnable"
          [mobileDarkSiteLogo]="isDarkSiteEnabled"
          [ngClass]="{ 'idp-global-nav-trip-logo': alternateFlow.enabled }"
        ></ngc-logo>
        <div class="superGraphicLogoDarksite"></div>
      </div>
      <div *ngIf="isLightHeaderFooterEnable" class="container">
        <ngc-logo
          [corpPartner]="corpPartner"
          [displayBusinessTypeSection]="displayBusinessTypeSection"
          [isLightHeaderFooterEnable]="isLightHeaderFooterEnable"
          [mobileDarkSiteLogo]="isDarkSiteEnabled"
          [ngClass]="{
            'idp-global-nav-trip-logo': alternateFlow.enabled,
            'm-auto': isLightHeaderFooterEnable
          }"
        ></ngc-logo>
      </div>
    </nav>
    <div
      #container
      #scrollDir="ngcScrollDirective"
      (clickedOutside)="clickedOutsideWidget($event)"
      (reachedTop)="showWidgetFromExternalEvent = false"
      *ngIf="!alternateFlow.enabled"
      [@widgetState]="widgetState"
      [childLabel]="selectedNavItem"
      [ngClass]="{
        'floating-header':
          scrollDir?.scrollCrossedWidget && showWidgetFromExternalEvent,
        'd-lg-none d-block': isSlimHeader && !isLightHeaderFooterEnable,
        'd-sm-none d-md-none d-lg-none d-none':
          isWidgetEnable ||
          isNotHome ||
          isLightHeaderFooterEnable ||
          !showHeaderWidget
      }"
      [ngStyle]="{
        'max-height.px': setWidgetMaxHeight(),
        'overflow-y': setWidgetOverFlow(),
        'top.px': isHeaderWidget() && showHeaderWidget ? widgetTop : ''
      }"
      [style.margin-top.px]="widgetContainerTop"
      [style.position]="widgetTopPosition"
      [viewInitialised]="isInitComplete"
      [widgetOffset]="widgetOffset"
      class="widget-container-lg nav-content-outlet bg-dark main-container collapse-widget"
      ngc-scroll-directive
    >
      <app-links-content-mobile-container
        (navItemClicked)="toggleContent($event)"
        *ngIf="isMobileAndTabletDevice"
        [highlightOnlyFirstItem]="true"
        [isMobileDevice]="isMobileDevice"
        [isSlimHeader]="isSlimHeader"
        [isloggedIn]="isloggedIn"
        [selectedItem]="selectedNavItem"
        class="d-block d-lg-none"
      ></app-links-content-mobile-container>
      <ngc-mobile-widget
        #ngcMobileWidget
        *ngIf="!isSlimHeader && isMobileAndTabletDevice"
        [corpPartner]="corpPartner"
        [custId]="custId"
        [isEDPFlag]="isEDPFlag"
        [mkcpgn]="mkcpgn"
        [prefCity]="prefCityCode"
        [queryParam]="queryParam"
        [selectedNavItem]="selectedNavItem"
      ></ngc-mobile-widget>
      <ng-container
        *ngIf="
          !isSlimHeader && !isMobileAndTabletDevice && !alternateFlow.enabled
        "
      >
        <ngc-book
          (advSearchExpanded)="updateWidgetOffset()"
          (errorPresent)="setHeaderWidget($event)"
          *ngIf="selectedNavItem === 'book' && !isMobileAndTabletDevice"
          [advanchedSearchClicked]="isadvanceSearch"
          [businessAccountOptionsList]="businessAccountOptionsList"
          [canBookNonRefundable]="canBookNonRefundable"
          [clickedOutside]="widgetOutsideClicked"
          [corpPartner]="corpPartner"
          [custId]="custId"
          [inMobile]="false"
          [isEDPFlag]="isEDPFlag"
          [mkcpgn]="mkcpgn"
          [prefCity]="prefCityCode"
          [queryParam]="queryParam"
          [shopExperience]="shopExperience"
          [triggerDefaultLookupEvent]="triggerDefaultLookupEvent"
          [widgetOnTop]="isHeaderWidget()"
          [widgetState]="setAdvSearchAnimation()"
          [isShoppingAwsFlow]="isShoppingAwsFlow"
          [widgetTopPosition]="widgetTopPosition"
          [isloggedIn]="isloggedIn"
          [nextgenPage]="nextgenPage"
        ></ngc-book>
        <ngc-checkin
          (errorPresent)="setHeaderWidget($event)"
          *ngIf="selectedNavItem === 'check_in' && !isMobileAndTabletDevice"
          [widgetOnTop]="isHeaderWidget()"
        ></ngc-checkin>
        <ngc-mytrips
          (errorPresent)="setHeaderWidget($event)"
          (myTripsLoaded)="myTripDataLoaded()"
          *ngIf="selectedNavItem === 'my_trips' && !isMobileAndTabletDevice"
        ></ngc-mytrips>
        <ngc-flight-status
          (errorPresent)="setHeaderWidget($event)"
          *ngIf="selectedNavItem === 'flightstatus' && !isMobileAndTabletDevice"
          [widgetOnTop]="isHeaderWidget()"
        ></ngc-flight-status>
      </ng-container>
    </div>
    <div
      [ngClass]="{
        'd-lg-block': !isLightHeaderFooterEnable,
        'legacy-bg-color': islegacyApp
      }"
      [ngStyle]="{
        'height.px': isHeaderWidget()
          ? setHeroImageHeight()
          : container?.offsetHeight + widgetContainerTop,
        'background-color': '#11172b'
      }"
      class="d-none nav-header-background-color"
    ></div>
  </div>
  <ngc-mobile-widget
    #ngcMobileWidget
    *ngIf="shopHeader && showMobileWidget"
    class="d-none"
    [corpPartner]="corpPartner"
    [custId]="custId"
    [isEDPFlag]="isEDPFlag"
    [mkcpgn]="mkcpgn"
    [prefCity]="prefCityCode"
    [queryParam]="queryParam"
    [selectedNavItem]="selectedNavItem"
  ></ngc-mobile-widget>

  <ngc-global-nav-slim
    (custId)="getCustId($event)"
    [mobileWidgetComponent]="ngcMobileWidget"
    [showMobileWidget]="showMobileWidget"
    *ngIf="shopHeader && !alternateFlow.enabled"
    [businessAccountOptionsList]="businessAccountOptionsList"
    [checkDefaults]="triggerDefaultLookupEvent"
    [corpPartner]="corpPartner"
    [isMobile]="isMobileDevice"
    [userId]="custId"
    [isShoppingAwsFlow]="isShoppingAwsFlow"
    [nextgenPage]="nextgenPage"
  ></ngc-global-nav-slim>
  <ngc-unsupported-browser
    [unsupportedbrowser]="unSupportedBrowser"
  ></ngc-unsupported-browser>
  <!-- <div class="cookie-footer text-left" *ngIf="showCookieTerms">
    <div class="container">
      <div class="row">
        <div class="col-11 p-0" tabindex="0" role="alert">
          <div class="alert-cookie-details">
            <div class="cookie-desc cookie-display-block">
              <p class="mb-0" innerHTML="{{ cookieDetails?.alertMessage }}">.</p>
            </div>
          </div>
        </div>
        <div class="close-cookie col-1 pr-0 pl-0">
          <button class="cookie-close-icon float-right circle-outline icon-moreoptionsclose" role="button" (click)="closeInfo()">
            <span class="sr-only">Close</span>
          </button>
        </div>
      </div>
    </div>
  </div> -->
</header>
